import { getCurrentEdition } from 'src/editions';

const currentEdition = getCurrentEdition();
const pluralOrgName = currentEdition.features.pluralOrgName;

export interface MenuItem {
  title: string;
  icon: string;
  route: string;
  show: boolean; // visible in the menu
  exact?: boolean;
}

export enum MainMenuOption {
  home = 'Home',
  union = 'Union',
  team = 'Team',
  player = 'Player',
  event = 'Event',
  assessment = 'Assessment',
  comprehensive = 'Comprehensive',
  tournament = 'Tournament',
  venue = 'Venue',
  user = 'User',
  iccreview = 'ICC Review',
  reports = 'Reports',
}

type MenuItemList = { [key in MainMenuOption]?: MenuItem };

// a lookup that links an icon with a human title and a url for display in the menu, search results etc
export const MainMenuItems: MenuItemList = {
  [MainMenuOption.home]: {
    title: 'Home',
    icon: 'wr-building',
    route: '/',
    show: true,
    exact: true,
  },
  [MainMenuOption.union]: {
    title: pluralOrgName,
    icon: 'wr-team-badge',
    route: '/unions',
    show: true,
  },
  [MainMenuOption.team]: {
    title: 'Teams',
    icon: 'wr-partnership',
    route: '/teams',
    show: true,
  },
  [MainMenuOption.player]: {
    title: 'Players',
    icon: 'wr-mens',
    route: '/players',
    show: true,
  },
  [MainMenuOption.event]: {
    title: 'Events',
    icon: 'wr-medical-bag', // book
    route: '/events',
    show: true,
  },
  [MainMenuOption.assessment]: {
    title: 'Assessments',
    icon: 'wr-programme',
    route: '/assessments',
    show: true,
  },
  [MainMenuOption.comprehensive]: {
    title: 'Comprehensives',
    icon: 'wr-temperature', // temperature
    route: '/comprehensives',
    show: true,
  },
  [MainMenuOption.tournament]: {
    title: 'Tournaments',
    icon: 'wr-competitions',
    route: '/tournaments',
    show: true,
  },
  [MainMenuOption.venue]: {
    title: 'Venues',
    icon: 'wr-map',
    route: '/venues',
    show: false, // Ed wanted the Venues shifted to inside Tournaments 6 June 22
  },
  [MainMenuOption.user]: {
    title: 'Users',
    icon: 'wr-identification',
    route: '/users',
    show: true,
  },
  [MainMenuOption.iccreview]: {
    title: 'ICC Reviews',
    icon: 'wr-assessment',
    route: '/iccreviews',
    show: true,
  },
  [MainMenuOption.reports]: {
    title: 'Reports',
    icon: 'wr-paper',
    route: '/reports',
    show: true,
  },
  // fixture is deliberately missing: we don't want it on the left menu because it is part of venues and tournaments
};

if (currentEdition.routeFilter?.includes('comprehensives')) {
  delete MainMenuItems[MainMenuOption.comprehensive]
}

if (currentEdition.routeFilter?.includes('iccreviews')) {
  delete MainMenuItems[MainMenuOption.iccreview]
} 
